"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var Alert = function Alert(_ref) {
  var type = _ref.type,
      message = _ref.message,
      title = _ref.title,
      dismissible = _ref.dismissible,
      dismissed = _ref.dismissed,
      onDismiss = _ref.onDismiss;

  var _useState = (0, _react.useState)(dismissed),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      localDismissed = _useState2[0],
      setLocalDismissed = _useState2[1];

  (0, _react.useEffect)(function () {
    setLocalDismissed(dismissed);
  }, [dismissed]);

  var onCloseClicked = function onCloseClicked() {
    setLocalDismissed(true);
    onDismiss && onDismiss();
  };

  if (dismissible && localDismissed) {
    return null;
  }

  var titleElement = title ? _react["default"].createElement("p", null, ' ', _react["default"].createElement("strong", null, " ", title, " "), ' ') : '';
  var dismissibleButton = dismissible ? _react["default"].createElement("button", {
    type: "button",
    className: "close",
    onClick: onCloseClicked
  }, "\xD7") : '';
  return _react["default"].createElement("div", {
    className: (0, _emotion.cx)('alert', "alert-".concat(type), {
      'alert-dismissible': dismissible
    })
  }, dismissibleButton, titleElement, message);
};

Alert.propTypes = {
  type: _propTypes["default"].oneOf(['success', 'info', 'warning', 'danger']),
  message: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].node,
  dismissible: _propTypes["default"].bool,
  dismissed: _propTypes["default"].bool,
  onDismiss: _propTypes["default"].func
};
Alert.defaultProps = {
  dismissible: true,
  dismissed: false,
  type: 'danger'
};
var _default = Alert;
exports["default"] = _default;